import { Trans, useLingui } from '@lingui/react/macro';

import InlineText from '@/design_system/Typography/InlineText';
import IconPackage from '@/icons/Package.svg';
import { BaseNotification } from '@/layouts/App/Navbar/NotificationList/components/BaseNotification/BaseNotification';
import type { TNotificationOfType } from '@/models/notification';

export const ShipmentToCreateNotification = ({
  notification,
}: {
  notification: TNotificationOfType<'shipment_to_create'>;
}) => {
  const { t } = useLingui();

  const requestReference = notification.request.reference;
  const workshopName = notification.data?.onBehalfOfWorkshopName;

  return (
    <BaseNotification
      notificationLabel={
        workshopName
          ? t({
              id: 'notification.shipment-to-create.label.on-behalf',
              message: `New shipment to create on behalf of workshop ${workshopName} for request ${requestReference}`,
            })
          : t({
              id: 'notification.shipment-to-create.label',
              message: `New shipment to create for request ${requestReference}`,
            })
      }
      icon={<IconPackage />}
      type="new"
      notification={notification}
      notificationHeader={(color) =>
        workshopName ? (
          <Trans id="notification.shipment-to-create.on-behalf">
            <InlineText weight="medium" color={color}>
              You
            </InlineText>{' '}
            have a new shipment to create on behalf of workshop{' '}
            <InlineText weight="medium" color={color}>
              {workshopName}
            </InlineText>
          </Trans>
        ) : (
          <Trans id="notification.shipment-to-create">
            <InlineText weight="medium" color={color}>
              You
            </InlineText>{' '}
            have a new shipment to create
          </Trans>
        )
      }
    />
  );
};
